import {defineMessages} from "@project/i18n";

export const routeMessages = defineMessages({
  admin: {
    id: "routes.module.admin",
    defaultMessage: "Admin",
    description: "Module label for admin section",
  },
  clientById: {
    id: "routes.client.byId",
    defaultMessage: "Client {clientId}",
    description:
      "Fallback route label for a client detail breadcrumb when client name is not loaded yet",
  },
  engineering: {
    id: "routes.module.engineering",
    defaultMessage: "Engineering",
    description: "Module label for engineering section",
  },
  expedientById: {
    id: "routes.expedient.byId",
    defaultMessage: "Expedient {expedientId}",
    description:
      "Fallback route label for an expedient detail breadcrumb when expedient name is not loaded yet",
  },
  expedients: {
    id: "routes.expedients",
    defaultMessage: "Expedients",
    description: "Route label for expedients section",
  },
  descriptions: {
    id: "routes.descriptions",
    defaultMessage: "Descriptions",
    description: "Route label for descriptions tab",
  },
  clients: {
    id: "routes.clients",
    defaultMessage: "Clients",
    description: "Route label for clients section",
  },
  commissions: {
    id: "routes.commissions",
    defaultMessage: "Commissions",
    description: "Route label for commissions tab",
  },
  contacts: {
    id: "routes.contacts",
    defaultMessage: "Contacts",
    description: "Route label for contacts tab",
  },
  dashboard: {
    id: "routes.dashboard",
    defaultMessage: "Dashboard",
    description: "Route label for dashboard page",
  },
  diagrams: {
    id: "routes.diagrams",
    defaultMessage: "Diagrams",
    description: "Route label for diagrams page",
  },
  leadById: {
    id: "routes.lead.byId",
    defaultMessage: "Lead {leadId}",
    description:
      "Fallback route label for a lead detail breadcrumb when lead name is not loaded yet",
  },
  materialById: {
    id: "routes.material.byId",
    defaultMessage: "Material {materialId}",
    description:
      "Fallback route label for a material detail breadcrumb when material name is not loaded yet",
  },
  materials: {
    id: "routes.materials",
    defaultMessage: "Materials",
    description: "Route label for materials section",
  },
  materialFunctions: {
    id: "routes.materialFunctions",
    defaultMessage: "Material functions",
    description: "Route label for material functions section",
  },
  serviceById: {
    id: "routes.service.byId",
    defaultMessage: "Service {serviceId}",
    description:
      "Fallback route label for a service detail breadcrumb when service name is not loaded yet",
  },
  services: {
    id: "routes.services",
    defaultMessage: "Services",
    description: "Route label for services section",
  },
  serviceFunctions: {
    id: "routes.serviceFunctions",
    defaultMessage: "Service functions",
    description: "Route label for service functions section",
  },
  leads: {
    id: "routes.leads",
    defaultMessage: "Leads",
    description: "Route label for leads section",
  },
  roleById: {
    id: "routes.role.byId",
    defaultMessage: "Role {roleId}",
    description:
      "Fallback route label for a Role detail breadcrumb when Role name is not loaded yet",
  },
  roles: {
    id: "routes.roles",
    defaultMessage: "Roles",
    description: "Route label for Roles section",
  },
  representativeById: {
    id: "routes.representative.byId",
    defaultMessage: "Representative {representativeId}",
    description:
      "Fallback route label for representative detail breadcrumb when company name is not loaded yet",
  },
  representatives: {
    id: "routes.representatives",
    defaultMessage: "Representatives",
    description: "Route label for representatives section",
  },
  preview: {
    id: "routes.preview",
    defaultMessage: "Preview",
    description: "Route label for preview tab",
  },
  notes: {
    id: "routes.notes",
    defaultMessage: "Notes",
    description: "Route label for notes tab",
  },
  offers: {
    id: "routes.offers",
    defaultMessage: "Offers",
    description: "Route label for offers tab",
  },
  offerById: {
    id: "routes.offer.byId",
    defaultMessage: "Offer {offerId}",
    description:
      "Fallback route label for an offer detail breadcrumb when offer name is not loaded yet",
  },
  offerTemplates: {
    id: "routes.offerTemplates",
    defaultMessage: "Offer templates",
    description: "Route label for offer templates section",
  },
  options: {
    id: "routes.options",
    defaultMessage: "Options",
    description: "Route label for options tab",
  },
  supplierById: {
    id: "routes.supplier.byId",
    defaultMessage: "Supplier {supplierId}",
    description:
      "Fallback route label for a supplier detail breadcrumb when supplier name is not loaded yet",
  },
  suppliers: {
    id: "routes.suppliers",
    defaultMessage: "Suppliers",
    description: "Route label for suppliers section",
  },
  supplierFunctions: {
    id: "routes.supplierFunctions",
    defaultMessage: "Supplier functions",
    description: "Route label for supplier functions section",
  },
  sales: {
    id: "routes.module.sales",
    defaultMessage: "Sales",
    description: "Module label for sales section",
  },
  settings: {
    id: "routes.settings",
    defaultMessage: "Settings",
    description: "Route label for settings page",
  },
  statistics: {
    id: "routes.statistics",
    defaultMessage: "Statistics",
    description: "Route label for statistics tab",
  },
  tasks: {
    id: "routes.tasks",
    defaultMessage: "Tasks",
    description: "Route label for tasks tab",
  },
  userManagement: {
    id: "routes.module.userManagement",
    defaultMessage: "User management",
    description: "Module label for user management section",
  },
  userById: {
    id: "routes.user.byId",
    defaultMessage: "User {userId}",
    description:
      "Fallback route label for a user detail breadcrumb when user name is not loaded yet",
  },
  users: {
    id: "routes.users",
    defaultMessage: "Users",
    description: "Route label for users section",
  },
});
